import { axiosInstance } from "./config";

export const getAllEmployees = async () => {
  try {
    const response = await axiosInstance.get('/employees');
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error("Failed to fetch employees:", error);
    return [];
  }
};

export const deleteEmployee = async (id) => {
  try {
    const response = await axiosInstance.delete(`/employees/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to delete employee:", error);
    throw error;
  }
};

